import {
  type schemaType,
  type returnType,
} from '~~/shared/api/strapi/contact-page/schema'
import {
  strapiServerFetchWrapper,
  strapiBrowserFetchWrapper,
} from '~~/server/utils/strapi/endpointWrapper'

const endpoint = '/contact-page'

export const serverFetch = (): Promise<returnType> =>
  strapiServerFetchWrapper<never, schemaType>(endpoint)

export const browserFetch = (): Promise<returnType> =>
  strapiBrowserFetchWrapper<never, schemaType>(endpoint)
